var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"subtitle-2"},[_vm._v(" "+_vm._s(_vm.props.display)+" ")]),_c('FormatUnit',{attrs:{"unit":_vm.$store.state.unit,"display-unit":true,"area":_vm.props.isArea,"metric-value":_vm.props.metricValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }